import { ControlledFormSelect } from '@components/formInputs/ControlledFormSelect';
import { LayoutVariant } from '@components/formInputs/sharedTypes';
import { useFormContext } from 'react-hook-form';
import { SettingsOutletHeader } from '../../shared/SettingsOutletHeader';
import {
  AVAILABILITY_INTERVAL_OPTIONS,
  YES_NO_SELECT_OPTIONS,
} from '../utils/generalSettingsFormHelpers';
import { type GeneralSettingsForm } from '../utils/generalSettingsFormTypes';
import layoutStyles from './AvailabilitiesSection.scss';

const AVAILABILITIES_BODY =
  'Interval sets the gap in minutes between reservable times. Optimize availabilities filters out table availabilities that would create dead time between reservations, helping increase seating capacity and overall efficiency.';

export interface AvailabilitiesSectionProps {
  sectionTitleId: string;
}

export const AvailabilitiesSection = ({
  sectionTitleId,
}: AvailabilitiesSectionProps) => {
  const { control } = useFormContext<GeneralSettingsForm>();

  return (
    <section className={layoutStyles.section} aria-labelledby={sectionTitleId}>
      <SettingsOutletHeader
        variant="section"
        titleId={sectionTitleId}
        title="Availabilities"
        subtitle={AVAILABILITIES_BODY}
      />
      <div className={layoutStyles.formFields}>
        <ControlledFormSelect
          control={control}
          label="Interval"
          name="availabilityInterval"
          options={AVAILABILITY_INTERVAL_OPTIONS}
          rules={{ required: true }}
          variant={LayoutVariant.Vertical}
          className={layoutStyles.constrainedField}
        />
        <ControlledFormSelect
          control={control}
          label="Optimize Availabilities"
          name="optimizeAvailabilities"
          options={YES_NO_SELECT_OPTIONS}
          rules={{ required: true }}
          variant={LayoutVariant.Vertical}
          className={layoutStyles.constrainedField}
        />
      </div>
    </section>
  );
};
